import { QUERY_KEYS } from "@cnx/common";

export type RevalidationItem = { key: QUERY_KEYS; id?: string };

type Listener = (id?: string) => Promise<void>;

class QueryInvalidationBus {
  private subscribers = new Map<QUERY_KEYS, Listener>();

  public subscribe(key: QUERY_KEYS, listener: Listener) {
    if (this.subscribers.has(key)) return;

    this.subscribers.set(key, listener);
  }

  public unsubscribe(key: QUERY_KEYS) {
    this.subscribers.delete(key);
  }

  public async notify(items: RevalidationItem[]) {
    if (!this.hasSubscribers()) return;

    const results = await Promise.allSettled(
      items.map(async item => this.subscribers.get(item.key)?.(item.id))
    );

    results.forEach((result, i) => {
      if (result.status === "rejected") {
        console.error(
          `[QueryInvalidationBus] Listener for key ${items[i].key} failed`,
          result.reason
        );
      }
    });
  }

  public getSubscribers() {
    return Array.from(this.subscribers.keys());
  }

  public hasSubscribers() {
    return this.subscribers.size !== 0;
  }
}

export const queryInvalidationBus = new QueryInvalidationBus();
